import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { Icon } from '../shared/icon';

// The heading of a group that folds: a chevron followed by its label, as tall as a dense table row. Used inside a
// table's group row and on its own above a table that the heading folds.
export function FoldableGroupHeading(t0) {
  const $ = _c(11);
  const {
    isCollapsed,
    onToggle,
    children
  } = t0;
  const t1 = !isCollapsed;
  let t2;
  if ($[0] !== onToggle) {
    t2 = event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onToggle();
      }
    };
    $[0] = onToggle;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center",
      gap: "4px",
      minHeight: "var(--foldable-group-heading-height, 30px)",
      padding: "0px 12px 0px 4px",
      cursor: "pointer",
      backgroundColor: "var(--mui-palette-action-hover)"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isCollapsed ? "material-symbols-keyboard-arrow-right-rounded" : "material-symbols-keyboard-arrow-down-rounded";
  let t5;
  if ($[3] !== t4) {
    t5 = <Icon iconClass={t4} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children || $[6] !== onToggle || $[7] !== t1 || $[8] !== t2 || $[9] !== t5) {
    t6 = <Stack direction="row" role="button" tabIndex={0} aria-expanded={t1} onClick={onToggle} onKeyDown={t2} sx={t3}>{t5}{children}</Stack>;
    $[5] = children;
    $[6] = onToggle;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}